import React, { FunctionComponent } from 'react';
import { Heading } from '@companion-professional/components';

interface ProfileSectionProps {
  sectionTitle: string;
  children: React.ReactNode;
}

export const ProfileSection: FunctionComponent<ProfileSectionProps> = ({ sectionTitle, children }) => {
  return (
    <div>
      <Heading level="subsection">{sectionTitle}</Heading>
      {children}
    </div>
  );
};
